// 博主端网页已停用（2026-09-19）。
//
// 博主端只走券宝宝 App 里的探店模块，网页这套不再维护。
// 留一个页面而不是直接删路由：这些链接发过给博主、也可能还在谁的收藏夹里，
// 落到空白页他会以为是坏了，然后来问运营。
import React from 'react';

export default function BloggerWebRetired() {
  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.title}>网页版已停用</div>
        <div style={s.body}>
          探店的报名、任务和消息都搬到 <b>券宝宝 App</b> 里了。
          <br />
          请打开券宝宝 App，在首页进入「博主探店」。
        </div>
        <div style={s.foot}>有问题联系跟你对接的运营同事</div>
      </div>
    </div>
  );
}

const s = {
  wrap: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#f7f7f8', padding: 24, boxSizing: 'border-box',
  },
  card: {
    maxWidth: 420, width: '100%', background: '#fff', borderRadius: 16,
    padding: '32px 24px', textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,.06)',
  },
  title: { fontSize: 20, fontWeight: 600, color: '#111', marginBottom: 14 },
  body: { fontSize: 15, lineHeight: 1.7, color: '#444' },
  foot: { fontSize: 13, color: '#9ca3af', marginTop: 22 },
};
